import { render } from "./PdfA4Page.vue?vue&type=template&id=0e168504&scoped=true&ts=true"
import script from "./PdfA4Page.vue?vue&type=script&lang=ts"
export * from "./PdfA4Page.vue?vue&type=script&lang=ts"

import "./PdfA4Page.vue?vue&type=style&index=0&id=0e168504&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e168504"]])

export default __exports__